export default "__VITE_ASSET__BEOOtjFS__"